const White = {
  level4: '#FFFFFF',
  level1: '#E3E3E3',
};

export { White };
